import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import authReducer from "../core/reducer/auth/authSlice";
import routeReducer from "../core/reducer/route/routeSlice";
import errorReducer from "../core/errors/errorSlice";
import loadReducer from "../core/loadSlice";
import pharmacyReducer from "../core/reducer/pharmacySlice";
import menuReducer from "../core/layout/nav/menuSlice";

export const store = configureStore({
  reducer: {
    auth: authReducer,
    route: routeReducer,
    menu: menuReducer,
    pharmacy: pharmacyReducer,
    errors: errorReducer,
    load: loadReducer,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
